<template>
  <div>
    <div v-show="isEdit" class="comment-edit">
      <div class="comment-edit_editor">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item label="内容" prop="content">
            <vditor-editor v-model="form.content" :height="200" />
          </a-form-model-item>
        </a-form-model>
      </div>
      <div>
        <a-button type="primary" style="margin-right: 16px" @click="onSubmit">确定</a-button>
        <a-button @click="onClose">取消</a-button>
      </div>
    </div>
    <a-comment v-for="comment in comments" :key="comment.id">
      <a-space slot="datetime">
        <a-tooltip :title="comment.created_time">
          <span>
            {{ comment.created_time }} <span v-if="comment.description">「{{ comment.description }}」</span>
          </span>
        </a-tooltip>
        <a v-if="showDelete(comment)" class="comment-delete" @click="onDelete(comment)"> 删除 </a>
      </a-space>
      <a slot="author">{{ comment.creator.nickname }}</a>
      <a-avatar slot="avatar" :src="comment.creator.avatar_url" />
      <template slot="content">
        <vditor-preview :content="comment.content" />
      </template>
    </a-comment>
  </div>
</template>
<script>
import { commentList, commentAdd, commentDelete } from '@/api/system/basic';

import VditorEditor from '@/components/VditorEditor';
import VditorPreview from '@/components/VditorEditor/preview';

export default {
  components: { VditorPreview, VditorEditor },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    },
    sourceType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      comments: [],
      form: {
        content: ''
      },
      isEdit: false,
      rules: {
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    showDelete() {
      return record => {
        return this.$store.state.userInfo.id === record.creator.id;
      };
    }
  },
  created() {
    this.getCommentList();
  },
  methods: {
    getCommentList() {
      commentList({ mode: this.sourceType, mode_id: this.sourceId }).then(res => {
        this.comments = res.data.items;
      });
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          commentAdd({ ...this.form, mode: this.sourceType, mode_id: this.sourceId })
            .then(() => {
              this.$message.success('提交成功');
              this.getCommentList();
              this.onClose();
            })
            .catch(() => {
              this.onClose();
            });
        }
      });
    },

    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除这条评论吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          commentDelete({ id: record.id }).then(() => {
            self.$message.success('删除成功');
            self.getCommentList();
          });
        }
      });
    },

    onAddComment() {
      this.$refs.form.resetFields();
      this.form.content = '';
      this.isEdit = true;
    },

    onClose() {
      this.$refs.form.resetFields();
      this.form.content = '';
      this.isEdit = false;
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-comment-inner) {
  padding: 8px 0;
}
:deep(.ant-form-item) {
  margin-bottom: 8px;
}
.comment-edit {
  background: #fafafa;
  padding: 8px;
  padding-top: 0;
  margin-bottom: 16px;
  .comment-edit_editor {
    width: 960px;
  }
}

.comment-delete {
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
  user-select: none;
}
</style>
